import { SELECIONAR_DISPONIBILIDADE_VEICULO } from '../../actions/types'

const initialState = null
const estadoInicial = {
  id: null,
  veiculo: {}
}

export default function reducerDisponibilidadeVeiculoSelecionado (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_DISPONIBILIDADE_VEICULO: {
      if (action.payload == null) {
        return estadoInicial;
      }
      return action.payload;
    }

    default: {
      return state
    }
  }
}